
import { Link, useLocation } from 'react-router-dom';

export default function Footer() {
  const location = useLocation();
  const isHvacPage = location.pathname === '/hvac';

  const scrollToSection = (sectionId: string) => {
    if (isHvacPage) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.location.href = `/hvac#${sectionId}`;
    }
  };

  return (
    <footer className="bg-[#0F3A2E] text-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-6 cursor-pointer">
              <div className="w-12 h-12 bg-[#C9A24D] rounded-lg flex items-center justify-center">
                <i className="ri-compass-3-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>
                Providence Path
              </h3>
            </Link>
            <p className="text-white/80 leading-relaxed">
              Helping small businesses grow with purpose and integrity. Transform your business while staying true to your values.
            </p>
          </div>

          {/* Industries */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-[#C9A24D]">Industries</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/hvac"
                  className="text-white/80 hover:text-[#C9A24D] transition-colors cursor-pointer whitespace-nowrap"
                >
                  HVAC Contractors
                </Link>
              </li>
              <li>
                <span className="text-white/50 whitespace-nowrap">
                  Plumbing Services (Coming Soon)
                </span>
              </li>
              <li>
                <span className="text-white/50 whitespace-nowrap">
                  Electrical Contractors (Coming Soon)
                </span>
              </li>
              <li>
                <span className="text-white/50 whitespace-nowrap">
                  General Contractors (Coming Soon)
                </span>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-[#C9A24D]">Resources</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/blog"
                  className="text-white/80 hover:text-[#C9A24D] transition-colors cursor-pointer whitespace-nowrap"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-white/80 hover:text-[#C9A24D] transition-colors cursor-pointer whitespace-nowrap"
                >
                  FAQ
                </Link>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-white/80 hover:text-[#C9A24D] transition-colors cursor-pointer whitespace-nowrap"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-[#C9A24D]">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/privacy"
                  className="text-white/80 hover:text-[#C9A24D] transition-colors cursor-pointer whitespace-nowrap"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm text-center md:text-left">
              © {new Date().getFullYear()} Providence Path. All rights reserved.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/60 hover:text-[#C9A24D] transition-colors text-sm cursor-pointer whitespace-nowrap"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
